import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import AccessControlDialog from "../../../dialogs/AccessControlDialog/AccessControlDialog";
import {
  createAccessControl,
  getCIDAccessConditions,
} from "../../../utils/services/lighthouse";
import History from "../../../utils/services/GlobalNavigation/navigationHistory";
import { notify } from "../../../utils/services/notification";
import "./AccessControl.scss";
import axios from "axios";
import Dialog from '@mui/material/Dialog';
import { getBlockchainType } from "../../../utils/services/auth";
import ReactLoading from "react-loading";
import { AiOutlineDelete } from "react-icons/ai";
import { DisclaimerBar } from "../../../components";

const getExistingAccessConditions = async (
  cid: string,
  setAllConditions: any,
  setValue: any,
  setCustomAggregator: any
) => {
  const response = await axios.get(
    `https://encryption.lighthouse.storage/api/fileAccessConditions/get/${cid}`
  );
  
  if (response?.data?.aggregator === '') {
    setCustomAggregator(false);
  } else {
    setCustomAggregator(true); 
  }

  let conditions:any = undefined;
  let aggregator:any = undefined;
  switch (getBlockchainType()) {
    case 'Coreum':
      conditions = response?.data?.conditionsCoreum
      aggregator = response?.data?.aggregatorCoreum
      break;
    case 'EVM':
      conditions = response?.data?.conditions
      aggregator = response?.data?.aggregator
      break;
    case 'Solana':
      conditions = response?.data?.conditionsSolana
      aggregator = response?.data?.aggregatorSolana
      break;
    case 'Radix':
      conditions = response?.data?.conditionsRadix
      aggregator = response?.data?.aggregatorRadix
      break;
    default:
      conditions = response?.data?.conditions
      aggregator = response?.data?.aggregator
      break;
  }
  setAllConditions(conditions);
  setValue("aggregator", aggregator);

};

function AccessControl() {
  const { cid } = useParams();
  const [isAccessControlDialog, setAccessControlDialog] = useState(false);
  const [currentCondition, setCurrentCondition] = useState<any>(null);
  const [isCustomAggregator, setCustomAggregator] = useState(false);
  const [allConditions, setAllConditions] = useState<any[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const form = useRef<HTMLFormElement>(null);

  useEffect(() => {
    let componentMounted = true;
    componentMounted &&
      getExistingAccessConditions(
        cid || "",
        setAllConditions,
        setValue,
        setCustomAggregator
      );
    return () => {
      componentMounted = false;
    };
  }, [cid]);

  useEffect(() => {
    let componentMounted = true;
    const condition = { ...currentCondition };
    const conditionArr = [...allConditions];
 
    if (condition.chain && !condition.id) {
      condition.id = allConditions.sort((a,b) => a.id - b.id).length > 0 ? Math.max(...allConditions.map(c => c.id)) + 1 : 1;
      conditionArr.push(condition);
      componentMounted && setAllConditions(conditionArr);
    }
    return () => {
      componentMounted = false;
    };
  }, [currentCondition]);



  const onSubmit = async (data: any) => {
    let aggregator = "";
    setIsloading(true);
    if (!isCustomAggregator) {
      if (
        data.condition1 &&
        data.condition2 !== "none" &&
        data.operator !== "none"
      ) {
        aggregator = `([${data.condition1}] ${data.operator} [${data.condition2}])`;
      } else {
        aggregator = `([${data.condition1}])`;
      }
    } else {
      aggregator = data.aggregator;
    }

    // console.log(allConditions,'allConditions')
    const response = await createAccessControl(
      cid || "",
      allConditions,
      aggregator
    );

    if (response?.data?.cid) {
      notify("Access Control Added !", "success");
      History.navigate("/dashboard");
    }else{

    }
  };

  const viewCondition = async (condition: any) => {
    setCurrentCondition(condition);
    setAccessControlDialog(true);
  };

  const deleteCondition = async (conditionID:number)=>{
    const filteredConditions = allConditions.filter(
      (condition) => condition.id !== conditionID
    );
    setAllConditions(filteredConditions);
    setValue("aggregator", "");
  }

  const removeAllConditions = async ()=>{
    setIsloading(true);
    const response = await createAccessControl(
      cid || "",
      allConditions,
      ""
    );
    if (response?.data?.cid) {
      notify("Access Control Removed !", "success");
      History.navigate("/dashboard");
    }else{

    }
  }

  return (
    isLoading ? <>
      <div className="loadingContainer">
          <ReactLoading
            type={"bubbles"}
            color={"#4452FE"}
            height={667}
            width={375}
          />
        </div>
    </> : 
    <div className="AccessControl">
      <div className="AccessControl__title">
        <p>Access Control</p>

     
     <div>
     <button
          onClick={() => {
            setAccessControlDialog(true);
          }}
          className="outlineBtn ptr"
        >
          Add New Condition
        </button>
        &nbsp;
        <button
          onClick={removeAllConditions}
          disabled={allConditions.length === 0}
          className="outlineBtn ptr"
        >
          Remove All Conditions
        </button>
     </div>
      </div>

      <div className="AccessControl__content">
        <div className="conditionsContainer">
          All Conditions
          <hr />
          <div className="cardContainer">
            {allConditions.map((condition: any, key: number) => (
              <div
                className="card"
                key={key}
               
              >
                <span onClick={()=>{deleteCondition(condition.id)}}>
                  <AiOutlineDelete/>
                </span>
                <div className="card__CardInner"  onClick={() => {
                  viewCondition(condition);
                }}>
                {`C${condition.id}`}
                </div>
                </div>
            ))}
          </div>
        </div>

        {allConditions.length > 0 && (
          <>
            <div className="aggregatorContainer">
              <div className="aggregatorContainer__title">
                <p>Create Aggregator</p>
                <ToggleButton
                  setTrue={setCustomAggregator}
                  isTrue={isCustomAggregator}
                  trueValue={"Custom <br/> ON"}
                  falseValue={"Custom <br/> OFF"}
                  type={""}
                />
              </div>

              <hr />
              <DisclaimerBar title={'How to Create Aggregator ?'} content={`Aggregators combine multiple conditions using logical operators for access control.<br/><br/>
<b>[1] and [2]</b> → Both must be true.<br/>
<b>[1] or [3]</b> → Either must be true.<br/>
<b>([1] and [2]) or [3]</b> → Both [1] & [2] or [3] must be true.<br/><br/>
No limit on conditions or associations—chain and nest them as needed!
                `}  />
              <form
                ref={form}
                className="form"
                onSubmit={handleSubmit(onSubmit)}
              >
                {isCustomAggregator ? (
                  <div style={{ width: "100%" }}>
                    <div className="fieldContainer">
                      <input
                        type="text"
                        placeholder="Custom Aggregator"
                        className={errors.aggregator ? "errorInput" : ""}
                        {...register("aggregator", { required: true })}
                      />
                      {errors.aggregator && (
                        <span className="fieldContainer__error">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex" }}>
                    <div
                      className="fieldContainer"
                      style={{ flex: "1", padding: "0px 5px" }}
                    >
                      <select
                        className={errors.condition1 ? "errorInput" : ""}
                        {...register("condition1", { required: true })}
                      >
                        {allConditions.map((condition: any, key: number) => (
                          <option
                            key={key}
                            value={`${condition.id}`}
                          >{`C${condition.id}`}</option>
                        ))}
                      </select>
                      {errors.condition1 && (
                        <span className="fieldContainer__error">
                          This field is required
                        </span>
                      )}
                    </div>
                    <div
                      className="fieldContainer"
                      style={{ flex: "1", padding: "0px 5px" }}
                    >
                      <select
                        className={errors.operator ? "errorInput" : ""}
                        {...register("operator", { required: true })}
                      >
                        <option value="none">None</option>
                        <option value="and">& (AND)</option>
                        <option value="or">|| (OR)</option>
                      </select>
                    </div>
                    <div
                      className="fieldContainer"
                      style={{ flex: "1", padding: "0px 5px" }}
                    >
                      <select
                        className={errors.condition2 ? "errorInput" : ""}
                        {...register("condition2")}
                      >
                        <option value={"none"}>None</option>
                        {allConditions.map((condition: any, key: number) => (
                          <option
                            key={key}
                            value={`${condition.id}`}
                          >{`C${condition.id}`}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                <button
                  className="fillBtn__blue ptr"
                  style={{
                    margin: "0",
                    width: "100%",
                  }}
                  type="submit"
                >
                  Create Access Control
                </button>
              </form>
            </div>
          </>
        )}
      </div>

      <Dialog
        open={isAccessControlDialog}
        onClose={() => {
          setAccessControlDialog(false);
        }}
      >
        <AccessControlDialog
          setAccessControlDialog={setAccessControlDialog}
          setCurrentCondition={setCurrentCondition}
          currentCondition={currentCondition}
        />
      </Dialog>
    </div>
  );
}

export default AccessControl;
